import React from 'react';
import { AdminPageHeader } from '../../components/admin/shell';
import IngestionPanel from '../../components/IngestionPanel';

export default function IngestionPage() {
  return (
    <>
      <AdminPageHeader section="ingestion" meta="Scraped sources, the review queue and claim requests." />
      <IngestionPanel />
    </>
  );
}
